// extracted by mini-css-extract-plugin
export var label = "_g2-0";
export var treatmentCard = "_g2-1";